import request from "@/utils/http"

export function saveDepartment({ id = null, name = "", parentId = "", adminIds = [] }) {
  return request.post("/users/saveDepartment", { id, name, parentId, adminIds }).commonDeal()
}

export function deleteDepartment(departmentId) {
  return request.post("/users/deleteDepartment", null, { params: { departmentId } }).commonDeal()
}
